import { render, staticRenderFns } from "./Kommunikationstypen-Test.vue?vue&type=template&id=8b527178&"
import script from "./Kommunikationstypen-Test.vue?vue&type=script&lang=js&"
export * from "./Kommunikationstypen-Test.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Kommunikationstypen-Test.vue"
export default component.exports